import ComponentHelper from '../../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import './migration-modal.css';
import { view, store } from 'react-easy-state';
import _ from 'lodash';
import Dropdown from '../../../components/dropdown/Dropdown';
import RESTService from '../../../services/RESTService';
import RoutingService from '../../../services/RoutingService';
import CommonService from '../../../services/CommonService';
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();
class MigrationModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = store({
			selected: '',
			title: this.props.title,
			envs: [],
			envMap: {}
		});
		this.autoBindAll(this, null, true);
	}

	componentDidMount() {
		connect
			.getTenantEnvironments(RS.getCurrentTenant())
			.then(res => {
				let sortedEnvs = [];
				let order = ['dev', 'qa', 'uat', 'prod'];
				let envMap = {};
				for (let i = 0; i < res.data.length; i++) {
					let key = res.data[i].name.toLowerCase();
					envMap[key] = res.data[i];
				}
				order.forEach(key => {
					sortedEnvs.push(envMap[key]);
					delete envMap[key];
				});
				let others = Object.values(envMap);
				others.sort(function(a, b) {
					let c = new Date(a.creationDate);
					let d = new Date(b.creationDate);
					return c - d;
				});
				let environments = sortedEnvs.concat(others);
				let finalEnvs = [];
				_.forEach(environments, e => {
					if (e.installedApps && Object.keys(e.installedApps).length > 0) {
						finalEnvs.push(e);
					}
				});
				this.data.envs = finalEnvs;
				this.data.envMap = CS.mapByParam('name', this.data.envs);
				console.log(this.data.envs);
			})
			.catch(err => {
				this.setData('loading', false);
				RS.smartError(err);
			});
	}

	onMoveNode() {
		this.props.onMove(this.data.selected);
	}

	onEnvChange(value) {
		this.data.selected = value.value;
	}

	getEnvs() {
		let options = [];
		_.forEach(this.data.envs, env => {
			options.push({
				label: _.upperCase(env.name),
				value: env.name
			});
		});
		return options;
	}

	render() {
		let { isOpen } = this.props;
		let { title, selected } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className="migration-modal animated zoomIn"
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
			>
				<div className="modal-header">{title}</div>
				<div className="modal-body">
					<Dropdown
						className="w-100"
						label="Environments"
						value={selected}
						placeholder="Select Environment"
						handleChange={this.onEnvChange}
						name="tenantPicker"
						options={this.getEnvs()}
						subText={'WARNING: Node must exist already in destination location'}
					/>
				</div>
				<div className="btn-ctn">
					<button className="btn cancel-btn" onClick={this.props.onCancel}>
						Cancel
					</button>
					<button className="btn primary" onClick={this.onMoveNode} disabled={selected.length <= 0}>
						Move
					</button>
				</div>
			</Modal>
		);
	}
}
export default view(MigrationModal);



// WEBPACK FOOTER //
// ./src/views/app-modules/migration-modal/MigrationModal.js